module.exports = __webpack_public_path__ + "static/ebook@2x-311530bedc7ab7d3b576d7cb1a8df1bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/ebook@2x.png
// module id = 2685
// module chunks = 157636680307020